/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { getInitiativeGroupTree } from '../../selectors/initiativeTree';
import './styles.scss'
import { createOptions } from '@features/header/ReportingLevelDropdown';
import { SelectFactory, SelectTypes, Option } from '@g17eco/molecules/select/SelectFactory';
import { GroupBase, StylesConfig } from 'react-select';
import { ReportingLevelOption } from '@g17eco/types/tree';

interface PortfolioSelectionProps {
  disabled?: boolean;
  placeholder: string;
  selectedPortfolioId?: string;
  handleSetPortfolio: (portfolioId: string) => void;
}

const nestedPadding = 12;

const getStyles = (): StylesConfig<Option | null, false, GroupBase<Option | null>> => ({
  option: (provided, state) => {
    const { isHidden, nested = 0 } = state.data as ReportingLevelOption;
    return {
      ...provided,
      display: isHidden ? 'none' : 'inline-block',
      paddingLeft: `${(nested ?? 1) * nestedPadding}px`,
      fontWeight: nested === 1 ? 'bold' : 'normal',
    };
  },
});

const PortfolioSelect = ({ placeholder, disabled, selectedPortfolioId, handleSetPortfolio }: PortfolioSelectionProps) => {
  const portfolioTree = useSelector(getInitiativeGroupTree);

  const reportingLevelOptions = createOptions(portfolioTree);

  const selectedPortfolio = selectedPortfolioId ? reportingLevelOptions.find(p => p.value === selectedPortfolioId) : null;

  return (
    <SelectFactory
      selectType={SelectTypes.SingleSelect}
      classNamePrefix='react-select'
      isDisabled={disabled}
      menuPlacement='auto'
      placeholder={placeholder}
      options={reportingLevelOptions}
      value={selectedPortfolio}
      styles={getStyles()}
      onChange={(o) => handleSetPortfolio(o?.value ?? '')}
    />
  );
}


export default PortfolioSelect;
